import { EmailNotSentRowOutDto, ENotSentAssessment } from '@app/swagger-types';

import { EmailCard } from '../../shared/EmailCard';
import { StatusPill, StatusPillVariant } from '../../shared/StatusPill';

const ASSESSMENT_VARIANT: Record<ENotSentAssessment, StatusPillVariant> = {
  [ENotSentAssessment.NORMAL]: 'mut',
  [ENotSentAssessment.INVESTIGATE]: 'warn',
  [ENotSentAssessment.UNKNOWN]: 'info',
};

const ASSESSMENT_LABEL: Record<ENotSentAssessment, string> = {
  [ENotSentAssessment.NORMAL]: 'normal',
  [ENotSentAssessment.INVESTIGATE]: 'investigate',
  [ENotSentAssessment.UNKNOWN]: 'not yet classified',
};

// admin-emailbeheer blok B (opdracht §4, "niet verstuurd, en waarom"). fromSendGrid marks
// SendGrid's own dropped-reasons apart from our skip_reason - "twee bronnen door elkaar".
export const EmailNotSentTable: React.FC<{ rows: EmailNotSentRowOutDto[] }> = ({ rows }) => {
  return (
    <EmailCard
      title="Not sent, and why"
      subtitle="Our own skip reasons and SendGrid's own dropped events, mixed together."
    >
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead>
            <tr className="border-b border-gray-200 text-gray-400">
              <th className="py-2 pr-3">Reason</th>
              <th className="py-2 pr-3">Source</th>
              <th className="py-2 pr-3">Mail key</th>
              <th className="py-2 pr-3 text-right">Count</th>
              <th className="py-2">Assessment</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={i % 2 === 1 ? 'bg-gray-50' : undefined}>
                <td className="font-mono py-1.5 pr-3">{row.reason || '-'}</td>
                <td className="py-1.5 pr-3 text-gray-400">{row.fromSendGrid ? 'SendGrid' : 'our own'}</td>
                <td className="py-1.5 pr-3 text-gray-500">{row.mailKey || '-'}</td>
                <td className="py-1.5 pr-3 text-right">{row.count.toLocaleString()}</td>
                <td className="py-1.5">
                  <StatusPill variant={ASSESSMENT_VARIANT[row.assessment]}>
                    {ASSESSMENT_LABEL[row.assessment]}
                  </StatusPill>
                </td>
              </tr>
            ))}
            {!rows.length && (
              <tr>
                <td colSpan={5} className="py-4 text-center text-gray-400">
                  Nothing went unsent in this period.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </EmailCard>
  );
};
